import TopcoScript from './TopcoScript';

export { TopcoScript };
